// extracted by mini-css-extract-plugin
export default {"varsel":"Varsel_varsel__vkvQu"};